(function () {
    'use strict';
    angular.module('app').directive('mediaWatcher', ['$window', '$timeout', function ($window, $timeout) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var tag = element[0].tagName.toLowerCase();

                if (tag === 'video') {
                    // Para vídeo HTML5 (MP4, MOV, etc.)
                    element.on('ended', function () {
                        scope.$apply(function () {
                            ngModel.$setViewValue(true);
                        });
                    });
                    
                    // SEGURO: Si el vídeo da error de carga, dejamos avanzar para no bloquear
                    element.on('error', function () {
                        // console.warn("Video load error, skipping validation to avoid blocking user.");
                        scope.$apply(function () {
                            ngModel.$setViewValue(true);
                        });
                    });
                } else if (tag === 'iframe') {
                    // Para YouTube: Usamos la API oficial de IFrame de Google
                    function initYT() {
                        // Si la API de YT no está cargada, la cargamos dinámicamente
                        if (typeof $window.YT === 'undefined' || typeof $window.YT.Player === 'undefined') {
                            if (!document.getElementById('youtube-api-script')) {
                                var tagScript = document.createElement('script');
                                tagScript.id = 'youtube-api-script';
                                tagScript.src = "https://www.youtube.com/iframe_api";
                                document.head.appendChild(tagScript);
                            }
                            $timeout(initYT, 500); // Reintentamos en medio segundo
                            return;
                        }

                        // Creamos el reproductor de YouTube para escuchar el evento ENDED
                        new $window.YT.Player(element[0].id, {
                            events: {
                                'onStateChange': function (event) {
                                    if (event.data === 0) { // 0 significa que el vídeo ha TERMINADO
                                        scope.$apply(function () {
                                            ngModel.$setViewValue(true);
                                        });
                                    }
                                }
                            }
                        });
                    }
                    $timeout(initYT, 500); // Esperamos a que Angular pinte el iframe
                }
            }
        };
    }]);
})();
